import { BookingDialogService } from '@sharedComponents/dialogs/booking-dialog/services/booking-dialog.service';
import { BookingDialogBaseEntity } from '@sharedComponents/dialogs/booking-dialog/services/classes/abstract/booking-dialog-base-entity';
import { BookingAttribute } from '@sharedComponents/dialogs/booking-dialog/enums/booking-attribute.enum';
import { BcmBookingsApiService } from '@bcmApiServices/bcm-bookings.api-service';
import { BookingExternalPayment } from '@shared/models/bcm-booking';

export class BookingDialogExternalPaymentData extends BookingDialogBaseEntity<BookingExternalPayment, BookingExternalPayment> {

    constructor(
        bookingDialogService: BookingDialogService,
        private _bookingsApiService: BcmBookingsApiService,
    ) {
        super(bookingDialogService, BookingAttribute.EXTERNAL_PAYMENT_DATA);
    }

    reload(): void {
        this._bookingsApiService.getExternalPaymentData(this.bookingDialogService.booking.id)
            .subscribe(externalPayment => {
                this.bookingDialogService.booking.externalPaymentData = externalPayment;
                this.value = externalPayment;
            });
    }
}
